import { MessageCircle, Mail } from "lucide-react";
import { IMAGES, WA_NUMBER_1, WA_NUMBER_2, waLink, trackEvent } from "@/data/content";

const Footer = () => (
  <footer data-testid="footer" className="bg-inavy text-white">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
        <div>
          <div className="inline-flex rounded-2xl bg-white p-2.5">
            <img src={IMAGES.logo} alt="IQMIZE logo" className="h-20 w-auto object-contain" data-testid="footer-logo" />
          </div>
          <p className="mt-4 text-lg font-bold">Maximize Your Mind.</p>
          <p className="mt-1 text-xs uppercase tracking-[0.25em] font-bold text-igold">
            Learn • Think • Grow • Achieve
          </p>
        </div>

        <div className="space-y-3">
          <div className="flex flex-wrap gap-3">
            <a
              href="mailto:info@iqmize.com"
              data-testid="footer-email-link"
              className="inline-flex items-center gap-2 rounded-full bg-igold px-5 py-2.5 text-sm font-bold text-slate-900 transition-[transform,background-color] duration-200 hover:-translate-y-0.5 hover:bg-igold-hover"
            >
              <Mail size={16} /> info@iqmize.com
            </a>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-sky-200">Talk to us on WhatsApp</p>
          <div className="flex flex-wrap gap-3">
            <a
              href={waLink(WA_NUMBER_1, "Hi IQMIZE!")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-1"
              onClick={() => trackEvent("whatsapp_click", { source: "footer", number: WA_NUMBER_1 })}
              className="inline-flex items-center gap-2 rounded-full bg-white/10 px-5 py-2.5 text-sm font-bold transition-colors duration-200 hover:bg-white/20"
            >
              <MessageCircle size={16} /> 70346 18014
            </a>
            <a
              href={waLink(WA_NUMBER_2, "Hi IQMIZE!")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-2"
              onClick={() => trackEvent("whatsapp_click", { source: "footer", number: WA_NUMBER_2 })}
              className="inline-flex items-center gap-2 rounded-full bg-white/10 px-5 py-2.5 text-sm font-bold transition-colors duration-200 hover:bg-white/20"
            >
              <MessageCircle size={16} /> 85905 66268
            </a>
          </div>
        </div>
      </div>

      <div className="mt-12 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-sky-100/70">© {new Date().getFullYear()} IQMIZE. Train Your Mind. Build Better Learning Habits.</p>
        <div className="flex items-center gap-5">
          <a href="/privacy" data-testid="footer-privacy-link" className="text-xs font-bold text-sky-100/80 hover:text-igold transition-colors duration-200">
            Privacy Policy
          </a>
          <p className="text-xs text-sky-100/70">IQMIZE — 7-Day Student Memory &amp; Learning System™</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
